import _ from "lodash";

import { MY_CALENDAR_CONSTANTS } from "Teacher/routes/Courses/routes/Course/routes/MyCalendar/constants/stringConstants";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  PROJECT_SUBTYPE_CORE,
  PROJECT_TYPE_DP_CAS,
  PROJECT_TYPE_SERVICE_AS_ACTION,
  STUDENT_ASSIGNMENT,
} from "Constants/stringConstants";

export const getProjectsHavingDeadline = projects => {
  return _.filter(
    projects,
    project =>
      !_.includes(
        [PROJECT_TYPE_SERVICE_AS_ACTION, PROJECT_TYPE_DP_CAS],
        project.type
      )
  );
};

export const addEntityAndProjectType = ({
  filters,
  projectGroups,
  currentCurriculumProgramType,
}) => {
  const filtersCopy = _.cloneDeep(filters);
  if (
    _.includes(
      [CURRICULUM_TYPE_MYP, CURRICULUM_TYPE_DP],
      currentCurriculumProgramType
    ) &&
    _.isArray(filtersCopy?.entityTypes)
  ) {
    filtersCopy.entityTypes.push(MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT);
  }
  filtersCopy.projectGroupIds = _.map(projectGroups, project => project.id);
  return filtersCopy;
};

export const getClassName = item => {
  return _.get(item, "project.projectGroup.courses.edges.0.node.title", "");
};

export const getProjectGroupName = item => {
  return _.get(item, "project.projectGroup.name", "");
};

/**
 *
 * @param {*} item => is the nested object containing project and projectGroup as a key and sub key
 * @param {*} itemType => string (type of project)
 * @returns string (project type )
 * @description  getItemType function takes item and itemType as an argument and check if itemType is Student assignment then return itemType else check if project type is core return the projectGroup type else return the projectGroup subtype
 */
export const getItemType = (item, itemType = "") => {
  if (itemType === STUDENT_ASSIGNMENT) {
    return itemType;
  }
  const projectSubType = _.get(item, "project.projectGroup.subType");

  return projectSubType === PROJECT_SUBTYPE_CORE
    ? _.get(item, "project.projectGroup.type")
    : projectSubType;
};

export const emptyStateIcons = {
  UPCOMING: "👀",
  OVERDUE: "🎊",
  NODUE: "🎉",
};

/**
 *
 * @param {*} allAcademicYears => is the  array of object containing  {endDate,id,isCurrentAcademicYear,isUpcomingAcademicYear,startDate,transitionReviewStatus}
 * @param {*} projectGroups => array of object containing object {
    "yearGroup": {
        "grade": {
            "globalGrade": {
                "uid"
            }
        }
    },
    "id",
    "name",
    "type",
    "subType",
    "curriculumProgram": {
        "id"
        "type"
    }
}
* @param {*} currentCurriculumProgramType => string 
 * @returns object {overDueStartDate,overDueEndDate}
 * @description  getOverDueStartAndEndDate function takes allAcademicYears, currentCurriculumProgramType and projectGroups as an argument and check if currentCurriculumProgramType is not DP then return currentAcademicYear end date as overDueEndDate and currentAcademicYear start date as overDueStarDate else if globalGradeName is DP_2(Grade 12) then return previous academic year startDate as overDueStartDate and currentAcademicYear endDate as overDueEndDate else return currentAcademicYear end Date as overDueStartDate and overDueEndDate can be same as overDueStartDate or can have future academic year date
 */
